import { Button } from "../Button";
import { useLocale } from "../../i18n/LocaleProvider";
import styles from "./questions.module.css";

interface SubmitRowProps {
  onNext: () => void;
  onSkip?: () => void;
  nextLabel?: string;
}

export function SubmitRow({ onNext, onSkip, nextLabel }: SubmitRowProps) {
  const { t } = useLocale();
  return (
    <div className={styles.submit}>
      {onSkip && <Button variant="ghost" onClick={onSkip}>{t.common.skip}</Button>}
      <Button variant="primary" onClick={onNext}>{nextLabel ?? t.common.next}</Button>
    </div>
  );
}
